export default {
  all: {
    id: 'bo_sellers-opportunities-inventory-filters-all',
    defaultMessage: 'All',
  },
}
